export const MODIFY_CLEANED_SOURCE_IDX = 'MODIFY_CLEANED_SOURCE_IDX';

export function modifyCleanedSourceIdx(cleanedSourceIdx){
    return{
        type: MODIFY_CLEANED_SOURCE_IDX,
        mainState: {
            cleanedSourceIdx: cleanedSourceIdx
        }
    }
}